import { RpcBaseData } from '../rpc-base';

/**
 * RPC seek request name and version.
 */
export class RpcSeekKey {
    public static command = 'Seek';
    public static version = '0.1.0';
}

/**
 * RPC seek mode.
 */
export enum RpcSeekMode {
    /**
     * Create new inbound rpc on the shell.
     */
    Create = 0,

    /**
     * Delete existing inbound rpc on the shell.
     */
    Delete = 1
}

export interface RpcSeek extends RpcBaseData {
    /**
     * Type of seek request.
     */
    mode: RpcSeekMode;
}

/**
 * Rpc Seek result.
 */
export interface RpcSeekResult {
    /**
     * name of module.
     */
    name: string;

    /**
     * sub name of frame instance.
     */
    subName: string;
}
